import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LaunchIcon from '@material-ui/icons/Launch';

const styles = {
    link: {
        textDecoration: 'none',
    },
    icon: {
        width: '0.5em',
        paddingLeft: 2,
    },
};

const MyUrlField = ({ record = {}, source, classes }) =>
    <a href={record[source]} className={classes.link}>
        {record[source]}
        <LaunchIcon className={classes.icon} />
    </a>;

export const GenericUrlField = withStyles(styles)(MyUrlField);
export const FilmOnVodUrlField = withStyles(styles)(({ record = {}, urlFactory, source, classes}) => {

    // console.log("Record is:", record, record[source], urlFactory(record));
    return (
        <a href={urlFactory(record)} className={classes.link} target="_blank" rel="noreferrer noopener">
            {record[source]}
            <LaunchIcon className={classes.icon} />
        </a>
    );
});
